module.exports = __webpack_public_path__ + "img/94.83982ffb.jpg";